import { idbGet, idbPut } from './idb';

type CatalogEnvelope = {
  id: string;
  rev?: string;
  items: any[];
  updatedAt: number;
};

const META_ID = 'catalog_versions';

export async function saveCatalogVersions(next: Record<string, string | undefined>) {
  await idbPut('catalog_meta', {
    id: META_ID,
    ...next,
    updatedAt: Date.now(),
  });
}

export async function loadCatalogVersions(): Promise<Record<string, string | undefined>> {
  return (await idbGet<Record<string, string | undefined>>('catalog_meta', META_ID)) || {};
}

export async function saveCategories(rev: string | undefined, items: any[]) {
  await idbPut('catalog_categories', { id: 'categories', rev, items, updatedAt: Date.now() } satisfies CatalogEnvelope);
}

export async function loadCategories(): Promise<CatalogEnvelope | null> {
  return await idbGet<CatalogEnvelope>('catalog_categories', 'categories');
}

export async function saveSubcategories(rev: string | undefined, items: any[]) {
  await idbPut('catalog_subcategories', { id: 'subcategories', rev, items, updatedAt: Date.now() } satisfies CatalogEnvelope);
}

export async function loadSubcategories(): Promise<CatalogEnvelope | null> {
  return await idbGet<CatalogEnvelope>('catalog_subcategories', 'subcategories');
}

export async function saveQuests(rev: string | undefined, items: any[]) {
  await idbPut('catalog_quests', { id: 'quests', rev, items, updatedAt: Date.now() } satisfies CatalogEnvelope);
}

export async function loadQuests(): Promise<CatalogEnvelope | null> {
  return await idbGet<CatalogEnvelope>('catalog_quests', 'quests');
}
